export const PREF_TOKEN = 'bearerToken'
export const IS_INTRO = '/'
export const IS_LOGIN = 'Login'
// API BASE URL
export const BASE_URL = "https://api.uprocure.utrade.tz/";
export const PAGE_LIMIT = 10
export const ORDER_PAGE_LIMIT = 100
// API TYPES
export const GET = 'GET'
export const GET_URL_PARAMS = 'GET_URL_PARAMS'
export const GET_ID_PARAMS = 'GET_ID_PARAMS'
export const GET_IDS_PARAMS = 'GET_IDS_PARAMS'
export const GET_URL_ENCODED = 'GET_URL_ENCODED'
export const GET_URL_ID_PARAMS = 'GET_URL_ID_PARAMS'
export const GET_URL_ID_PARAMS_WITH_MULTIPLE_STATUS = 'GET_URL_ID_PARAMS_WITH_MULTIPLE_STATUS'
export const POST = 'POST'
export const PATCH_FORM_ID_V2 = "PATCH_FORM_ID_V2"
export const POST_ID_PARAMS = 'POST_ID_PARAMS'
export const POST_RAW = 'POST_RAW'
export const POST_FORM = 'POST_FORM'
export const POST_URL_ENCODED = 'POST_URL_ENCODED'
export const POST_URL_PARAMS = 'POST_URL_PARAMS'
export const POST_URL_ENCODED_ID_PARAMS = 'POST_URL_ENCODED_ID_PARAMS'
export const GET_URL_PARAMS_WITH_MULTIPLE_STATUS =
  "GET_URL_PARAMS_WITH_MULTIPLE_STATUS";
export const MULTI_PART_POST = 'MULTI_PART'
export const PATCH = 'PATCH'
export const PATCH_ID = 'PATCH_ID'
export const PATCH_FORM = 'PATCH_FORM'
export const PATCH_FORM_ID = 'PATCH_FORM_ID'
export const PATCH_URL_ENCODED = 'PATCH_URL_ENCODED'
export const PATCH_FORM_ID_URL_ENCODED = 'PATCH_FORM_ID_URL_ENCODED'
export const MULTI_PART_ID_POST = 'MULTI_PART'
export const MULTI_PART_ID_PATCH = 'MULTI_PART_PATCH'
export const DELETE = 'DELETE'
export const DELETE_URL_PARAMS = 'DELETE_URL_PARAMS'
export const DELETE_URL_ENCODED = 'DELETE_URL_ENCODED'
export const DELETE_ID_PARAMS = 'DELETE_ID_PARAMS'
export const MULTI_PART_ID_DELETE = "MULTI_PART_ID_DELETE";

//Response
export const ResponseFail = 400
export const ResponseSuccess = 200
export const AuthError = 401
export const Maintenance = 503
//Kyc Status
export const All = 1;
export const NewRequests = 2;
export const Submitted = 1
export const UnderReview = 2
export const InfoRequired = 3
export const Accepted = 4
export const Rejected = 5
//Product State Enum
export const AllProduct = 1
export const Actived = 2
export const Deactivated = 3
export const VerificationPending = 4
export const ProductRejectedState = 5
//Quantity Enum
export const CartonWithDozens = 1
export const Dozen = 2
export const Piece = 3
export const CartonWithPieces = 4
//Technical Details Enum
export const SingleLineText = 1
export const MultiLineText = 2
export const SingleSelection = 3
export const MultiSelection = 4
export const DateSelection = 5
//Variants Defined By Enum
export const Skip = 0;
export const SuggestOptions = 1;
export const TextGuide = 2;
//Product Status
export const ProductAccepted = 2
export const ProductUnderReview = 3
export const ProductRejected = 4
export const ApprovedProduct = 2;
export const PendingProduct = 3;
export const OutOfStockList = 15;
export const RejectedProduct = 4;
// Orders Status
export const NewOrder = 1
export const PreparingForDispatch = 2
export const Delivered = 3
export const Cancelled = 4
//Advertisement Type
export const HomePage = 1
export const CategoryPage = 2
//Advertisement Product Type
export const SingleProduct = 1
export const MultipleProduct = 2
//Advertisement State
export const AdvertisementRequest = 1
export const AdvertisementAccepted = 2
export const AdvertisementOngoing = 3
export const AdvertisementUpcoming = 4
export const AdvertisementCompleted = 5
//Advertisement PaymentStatuses
export const AdvertisementPaid = 1
export const AdvertisementUnpaid = 2
//Advertisement PaymentMethods
export const Card = 1
export const Cash = 2
//Inventory Transaction/History
export const ShipmentThroughAdded = 'c1' //New Stock Updated
export const AddedOnReturn = 'c2' //Customer return
export const ManuallyAdded = 'c3' //New Stock Updated
export const DirectlyReceived = 'c4' //New Stock Updated
export const AddedOnOrderCancellation = 'c5' //Order modified
export const AddedOnOrderModification = 'c6' //Order modified
export const AddedOnConversion = 'c7'; //Order modified
export const AddedInterTransferRequest = 'c8';
export const DeductedOnSale = 'd1' //New order
export const DeductedOnReturnToSeller = 'd2' //Goods return request
export const ManuallyDeducted = 'd3' //Missing/Damaged goods
export const DeductedOnMissing = 'd4' //Missing/Damaged goods
export const DeductedOnDamage = 'd5' //Missing/Damaged goods
export const DeductedOnOrderModification = 'd6' //Order modified
export const DeductedOnConversion = 'd7'; //Order modified
export const TransferRequest = 'd8'
//Shipment Status
export const ShipmentSubmitted = 1
export const ShipmentAccepted = 2
export const ShipmentCancelled = 3
export const ShipmentRejected = 4
export const ShipmentPickedUp = 5
export const ShipmentDelivered = 6
export const ShipmentCompleted = 7
export const ShipmentPickedUpStarted = 8
export const ShipmentPartialDelivered = 9;
//User Types
export const SuperAdmin = 2
export const Vendor = 1
//Shipment Type
export const SelfTransport = 1
export const UTradeTransport = 2;
export const UWordTransport = 3;

//Shipment Fees
export const WarehouseStorage = 1
export const Shipping = 2
//Order Status
export const OrderSubmitted = 1 //New-order-placed
export const OrderProcessed = 2 //Route-planning generated
export const OrderOutForDelivery = 3 //out for delivery
export const OrderDelivered = 4 //Delivered
export const OrderCancelled = 5 //Cancelled
//Tax Types
export const GeneralTax = 1
export const SystemTax = 2
//Order Payment method
export const OrderCash = 1
export const OrderTigoPesa = 2
export const OrderMPesa = 3
export const OrderCard = 4
//Google autocomplete apikey
export const APIkey = 'AIzaSyAg41o-JrOGvOov4uDRb9CzL2AyfUMYDbI'

export const BankPayment = 1;
export const TigoPesaPayment = 2;
//Roles
// export const All = 0;
export const View = 1;
export const Add = 2;
export const Edit = 3;
export const Delete = 4;
export const Download = 5;
//Admin UserType
export const Admin = 1;
export const AssistAdmin = 2;
//Assist Admin User Role
export const Manager = 1;
export const ServiceMember = 2;
export const FinanceManager = 3;
export const LoadingBayManager = 4;
export const FulfillmentManager = 5;
//Permissions module
export const AllModules = 0;
export const Vendors = 1;
export const Inventory = 2;
export const POManagement = 3;
export const GoodsReceivedNote = 4;
export const GoodsRequests = 5;
export const AllVendors = 6;
export const PendingCertificates = 7;
export const PaymentsToVendors = 8;
export const UTrade = 9;
export const UMart = 10;
export const LowStockList = 11;
export const AssignProductsToVendors = 12;
export const Product = 2;
export const Sellers = 1;
export const AllSeller = 2;
export const KycVerifications = 3;
export const PendingCertificate = 4;
export const PaymentToSellers = 5;
export const SellersSalesReport = 6;
export const Customers = 7;
export const AllCustomers = 8;
export const RefundsToCustomer = 9;
export const ReceivableReports = 10;
export const OrdersDelivery = 11;
export const RoutePlan = 12;
export const Master = 13;
export const Category = 14;
export const BusinessType = 15;
export const BusinessCertificates = 16;
export const Brand = 17;
export const TechnicalDetails = 18;
export const ProductVariants = 19;
export const MasterProduct = 20;
export const Driver = 21;
export const Vehicle = 22;
export const VehicleLoadingArea = 23;
export const SellerProductZone = 24;
export const FinanceMember = 25;
export const RolesAndPermission = 26;
export const UserManagement = 27;
// export const Inventory = 28;
export const GoodsWarehouse = 29;
export const LowStockLists = 30;
export const GoodsRequest = 31;
export const ReceivedDirectGood = 32;
export const CustomerServices = 33;
export const All_Products = 34;
export const PlatformFees = 35;
export const Advertising = 36;
export const ContactInquires = 37;
export const CustomNotifications = 38;
export const Settings = 39;
export const Privacy_Policy = 40;
export const TermsConditions = 41;
export const AppSettings = 42;
export const Dashboard = 43;
export const FinanceReports = 44;
export const OutWardReports = 45;
export const ReturnProductReports = 46;
export const DeliveryReports = 47;
export const Reports = 48;
export const CustomerPurchaseBehaviourReport = 49;
export const GeographicSalesInsightReport = 50;
export const AreaBasedCustomerSegmentationReport = 51;
export const FrequentCustomerPurchasePatternAnalysisReport = 52;
export const ProductSalesPerformanceReport = 53;
export const BrandWiseSalesPerformanceReport = 54;
export const CategoryAndSubCategoryAnalysisReport = 55;
export const RevenueGenerationReport = 56;
export const CommissionAnalysisReport = 57;
export const InventoryStatusReport = 58;
export const InterTransferUmart = 59
export const PreOrderCustomerList = 60;
export const WarehouseModule = 61;
export const WarehouseManger = 62;
export const WarehouseInterTransfer = 63;

export enum PermissionModule {
  AllModules = 0,
  Sellers = 1,
  AllSeller = 2,
  KycVerifications = 3,
  PendingCertificate = 4,
  PaymentToSellers = 5,
  SellersSalesReport = 6,
  Customers = 7,
  AllCustomers = 8,
  RefundsToCustomer = 9,
  ReceivableReports = 10,
  OrdersDelivery = 11,
  RoutePlan = 12,
  Master = 13,
  Categories = 14,
  BusinessType = 15,
  BusinessCertificates = 16,
  Brand = 17,
  TechnicalDetails = 18,
  ProductVariants = 19,
  MasterProduct = 20,
  Driver = 21,
  Vehicle = 22,
  VehicleLoadingArea = 23,
  SellerProductZone = 24,
  FinanceMember = 25,
  RolesAndPermission = 26,
  UserManagement = 27,
  Inventory = 28,
  GoodsWarehouse = 29,
  LowStockLists = 30,
  GoodsRequest = 31,
  ReceivedDirectGood = 32,
  CustomerServices = 33,
  All_Products = 34,
  PlatformFees = 35,
  Advertising = 36,
  ContactInquires = 37,
  CustomNotifications = 38,
  Settings = 39,
  Privacy_Policy = 40,
  TermsConditions = 41,
  AppSettings = 42,
  Dashboard = 43,
  FinanceReports = 44,
  OutWardReports = 45,
  ReturnProductReports = 46,
  DeliveryReports = 47,
  Reports = 48,
  CustomerPurchaseBehaviourReport = 49,
  GeographicSalesInsightReport = 50,
  AreaBasedCustomerSegmentationReport = 51,
  FrequentCustomerPurchasePatternAnalysisReport = 52,
  ProductSalesPerformanceReport = 53,
  BrandWiseSalesPerformanceReport = 54,
  CategoryAndSubCategoryAnalysisReport = 55,
  RevenueGenerationReport = 56,
  CommissionAnalysisReport = 57,
  InventoryStatusReport = 58,
  InterTransferUmart = 59,
  PreOrderCustomerList = 60,
  WarehouseModule = 61,
  WarehouseManger = 62,
  WarehouseInterTransfer = 63,
  // here below add quotation module in future
  PendingDeliveryOrder = 65,
  OutOfStockList = 66,
  OutstandingReport = 67,
  DriverLedger = 68,
  DistrictAndCity = 69,
  CustomerLedger = 70,
  PriceUpdateRequest = 71,
  RouteProductReports = 72,
  POManagement = 73,
  //vendors
  AllVendors = 74,
  PaymentToVendors = 75,
  AssignProductToVendors = 76,
  GoodsReceivedNote = 77,
  Escalations = 78,
  VendorLedger = 79,
  // Sales Management
  OutOfStockReportPermission = 80,
  SalesDashboard = 81,
  SalesRepresentative = 82,
  CustomerAssignment = 83,
  TargetManagement = 84,
  SalesRepOrders = 85,
  SalesAlerts = 86,
  FinanceSalesReportPermission = 87,
  FinanceReturnReportPermission = 88,
  FinanceDeliveryReportPermission = 89,
  ProductReturnRequests = 90,
  UProcure = 91,
  UProcureDashboard = 92
}
export const Categories = PermissionModule.Categories;

import { getKey } from '../Global/history';
import { warehouse } from './storeString';

export const warehouseRef = (() => {
  const storedStatus = getKey(warehouse.warehouseRef);
  if (typeof storedStatus === 'string') {
    return JSON.parse(storedStatus);
  }
  return storedStatus ?? null;
})();